import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';

import membershipStore from '../../stores/membershipStore';
import Loader from '../../components/Loader';
import UserSubscriptionListing from './components/UserSubscriptionListing';
import MembershipListing from './components/MembershipListing';
import Col12 from './components/Col12';
import BillingFormMembership from '../../components/billing-form/BillingFormMembership';
import Cart from './components/Cart';
import { T } from '../../stores/textStore';
import { loadPromotion } from '../../actions/membershipActions';


class ChangUserSubscriptionsView extends Component {
	componentDidMount() {		
		membershipStore.alerts.replace([]);
		const { slug } = this.props.match.params;
		membershipStore.changeForm.set('membership', slug);
		loadPromotion();
	}

	render() {				
		if (!membershipStore.isDataLoaded() || !membershipStore.changeForm.get('membership')) {
			return (
				<Col12>
					<Loader message={membershipStore.processingMessage.get()} />
				</Col12>
			);
		}
		const { history } = this.props;
		if (membershipStore.changeFormProcessError.get()) {
			history.push('/error');
			return null;
		}		
		if (membershipStore.changeFormProcessSuccess.get()) {
			//history.push('/thank-you');
			window.location.replace("/paths/" + window.location.search);
			return null;
		}
		const membershipSlug = membershipStore.changeForm.get('membership');
		const membership = membershipStore.getMembershipBySlug(membershipSlug) 
		const currentUserSubscription = membershipStore.getCurrentUserSubscription();
		const pendingUserSubscription = membershipStore.getPendingUserSubscription();	
		if (pendingUserSubscription) {
			return (
				<div className="container mt-4">
					<div className="row">
						<div className="col-lg-4">
							<div className="alert-warning text-center py-2" role="alert">
								{T('You have a pending plan')}
							</div>
							<p className="text-center">
								{T('You cannot make changes to your current membership plan because you have the following pending plan that will take effect on')}
								&nbsp;{pendingUserSubscription.start_date}.
							</p>
							<UserSubscriptionListing userSubscription={pendingUserSubscription} />
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className="container mt-4">
				<div className="row">
					<div className="col-lg-5 order-lg-2">							
						<Cart />	
					</div>						
					<div className="col-lg-7 order-lg-1">	
						<h4>{T('Billing Information')}</h4>		
						<BillingFormMembership />	
					</div>																		
				</div>
			</div>
		);		
	}
}

export default withRouter(observer(ChangUserSubscriptionsView));



// WEBPACK FOOTER //
// ./src/views/membership/UserSubscriptionsChangeView.js